/**
 * Есть ли вариант дешевле выбранного — по уже посчитанной таблице сравнения.
 *
 * Своей цены здесь не считается: на вход приходят те же строки, которые показывает
 * «Сравнение стоимости производств», с их готовыми итогами. Производство не
 * переключается и ручной выбор не снимается — это только предупреждение.
 */

const totalOf = (row) => {
  const value = Number(row?.totalSum);
  return Number.isFinite(value) && value > 0 ? value : null;
};

const productionOf = (row) => String(row?.production || row?.comparison?.production || '').trim();

// Ключ выбранного производства — comparison.id: это имя производителя вместе с
// источником прайса, а в строке показывается productionInfo.NAME без него. Ищем по
// обоим, иначе выбранная строка не находится.
const comparisonIdOf = (row) => String(row?.comparison?.id ?? row?.id ?? '').trim();

/**
 * @param {object}  params
 * @param {Array}   params.rows                — строки сравнения (sortedGroupedData)
 * @param {string}  params.selectedProduction  — выбранное производство
 * @param {boolean} params.isMskGazobetonScope — признак области, приходит готовым
 * @returns {{isCheapest: boolean, selected: object|null, cheapest: object|null, difference: number}|null}
 */
export const buildGazCheapestHint = ({ rows, selectedProduction, isMskGazobetonScope } = {}) => {
  if (!isMskGazobetonScope) {
    return null;
  }

  const usable = (Array.isArray(rows) ? rows : [])
    .filter((row) => !row?.isReagent && !row?.hasDeliveryError && totalOf(row) !== null && productionOf(row))
    .map((row) => ({
      production: productionOf(row),
      comparisonId: comparisonIdOf(row),
      total: totalOf(row),
    }));

  if (usable.length === 0) {
    return null;
  }

  const cheapest = usable.reduce((best, row) => (row.total < best.total ? row : best), usable[0]);
  const name = String(selectedProduction || '').trim();
  const selected = usable.find((row) => row.comparisonId === name)
    || usable.find((row) => row.production === name)
    || null;

  if (!selected) {
    return null;
  }

  const difference = Math.max(Math.ceil(selected.total) - Math.ceil(cheapest.total), 0);

  return {
    isCheapest: difference === 0,
    selected,
    cheapest,
    difference,
  };
};

export default buildGazCheapestHint;
